

















import { Vue, Prop, Component } from "vue-property-decorator";
import CourseRegistrationsTable from "@/components/courses/CourseRegistrationsTable.vue";
import StudentTable from "@/components/students/StudentTable.vue";
import { LearningRequest as ILearningRequest } from "@/api/models";

@Component({
  components: {
    StudentTable,
    CourseRegistrationsTable
  }
})
export default class StudentInfoTables extends Vue {
  @Prop() request!: ILearningRequest;
  @Prop() registrations!: any;
  @Prop() students!: any;

  data() {
    return {};
  }

  mounted() {
    // console.log(this.request);
    // console.log(this.registrations);
  }
}
